import { createAppStore } from './createStore'

export default createAppStore()
